module.exports = __webpack_public_path__ + "static/media/guide_img2_3_m.56738fff.png";